import { HOUSEHOLD_DOC, TRACKERS_DOC, TRACKER_DOC_PREFIX } from '@awwyeah/shared';
import type { WebModule } from '../registry';
import { TrackerDayPage } from './TrackerDayPage';

/**
 * Trackers (client side, 2026-08-18 — "a Sanders tracker", and whatever else the house
 * wants to keep an eye on).
 *
 * **No `nav` entry and no routes of its own.** Both surfaces are embedded: `TrackersSection`
 * renders inside the existing Apps tab (same owner call as `GamesSection` — the brief
 * tolerates 0–6 bottom-tabs and we are at six), and `PinnedTrackers` renders on the digest.
 * The module still registers so its docs are subscribed and so the registry knows it
 * exists — the same shape `household` and `dev` use (docs/DECISIONS.md 2026-07-31), minus
 * the routes they need and this doesn't.
 *
 * `tracker:` is a **prefix** subscription: one doc per tracker, resolved at open time from
 * the registry, exactly like `list:` and `game:`.
 *
 * One route (2026-09-25): `/trackers/:trackerId`, the day view — plan next to actual for one
 * tracker at a time. Still no `nav` entry; it's reached from a tracker card, same as a list's
 * detail page is reached from the list index rather than from the bottom nav.
 */
export const trackersWebModule: WebModule = {
  id: 'trackers',
  routes: [{ path: '/trackers/:trackerId', component: TrackerDayPage }],
  docs: [TRACKERS_DOC, TRACKER_DOC_PREFIX, HOUSEHOLD_DOC],
};

/** The Apps-tab management surface. */
export { TrackersSection } from './TrackersSection';
/** The digest's pinned-tracker cards — the "has anyone fed the dog" glance. */
export { PinnedTrackers } from './PinnedTrackers';
/** A tracker's day view — plan vs. actual, one day at a time. */
export { TrackerDayPage } from './TrackerDayPage';
